<template>
    <div class="p-your-claims__table-container">
        <div class="flex-grid flex-state-buttons">
            <div>
                <div class="a-checkbox">
                    <input autocomplete="off" type="checkbox" v-model="showInterest" @change="updateTotals">
                    <label for="text">Show Interest</label>
                </div>
            </div>
        </div>
        <table class="a-table u-full-width">
            <thead>
            <tr>
                <th rowspan="2"><h2>Heads of Loss</h2></th>
                <th rowspan="2"><h2>Defendant's Assessment</h2></th>
                <th rowspan="2"><h2>Claimant's Assessment</h2></th>
                <th colspan="2"><h2>Difference</h2></th>
            </tr>
            <tr>
                <th><h2>&pound;</h2></th>
                <th><h2>Percentage</h2></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>General Damages (PSLA)</td>
                <td>{{ currencyFormat(headOfLoss('generalDamages')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_general_damages" label="" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="generalDamages"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('generalDamages') - generalDamages) }}</td>
                <td>{{ roundAndPercent(headOfLoss('generalDamages'), generalDamages) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>General Damages (PSLA) - Interest</td>
                <td>{{ currencyFormat(headOfLoss('generalDamagesWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_general_damages_interest" label="" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="generalDamagesInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('generalDamagesWithInterest') - generalDamagesInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('generalDamagesWithInterest'), generalDamagesInterest) }}%</td>
            </tr>
            <tr>
                <td>Funeral Expenses</td>
                <td>{{ currencyFormat(headOfLoss('funeralExpenses')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_funeral_expenses" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="funeralExpenses"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('funeralExpenses') - funeralExpenses) }}</td>
                <td>{{ roundAndPercent(headOfLoss('funeralExpenses'), funeralExpenses) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Funeral Expenses - Interest</td>
                <td>{{ currencyFormat(headOfLoss('funeralExpensesWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_funeral_expenses" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="funeralExpensesInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('funeralExpensesWithInterest') - funeralExpensesInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('funeralExpensesWithInterest'), funeralExpensesInterest) }}%</td>
            </tr>
            <tr>
                <td>Loss of Spouse</td>
                <td>{{ currencyFormat(headOfLoss('lossOfSpouse')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_loss_of_spouse" before-after="pound" :table-control="true">
                            <input autocomplete="off" v-model.number="lossOfSpouse"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('lossOfSpouse') - lossOfSpouse) }}</td>
                <td>{{ roundAndPercent(headOfLoss('lossOfSpouse'), lossOfSpouse) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Loss of Spouse - Interest</td>
                <td>{{ currencyFormat(headOfLoss('lossOfSpouseWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_loss_of_spouse" before-after="pound" :table-control="true">
                            <input autocomplete="off" v-model.number="lossOfSpouseInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('lossOfSpouseWithInterest') - lossOfSpouseInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('lossOfSpouseWithInterest'), lossOfSpouseInterest) }}%</td>
            </tr>
            <tr>
                <td>Past Loss Of Earnings</td>
                <td>{{ currencyFormat(headOfLoss('pastLossOfEarnings')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_loss_of_earnings" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastLossOfEarnings"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastLossOfEarnings') - pastLossOfEarnings) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastLossOfEarnings'), pastLossOfEarnings) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Past Loss Of Earnings - Interest </td>
                <td>{{ currencyFormat(headOfLoss('pastLossOfEarningsWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_loss_of_earnings" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastLossOfEarningsInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastLossOfEarningsWithInterest') - pastLossOfEarningsInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastLossOfEarningsWithInterest'), pastLossOfEarningsInterest) }}%
                </td>
            </tr>
            <tr>
                <td>Past Cost of Travel</td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfTravel')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_cost_of_travel" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastCostOfTravel"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfTravel') - pastCostOfTravel) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastCostOfTravel'), pastCostOfTravel) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Past Cost of Travel - Interest</td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfTravelWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_cost_of_travel" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastCostOfTravelInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfTravelWithInterest') - pastCostOfTravelInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastCostOfTravelWithInterest'), pastCostOfTravelInterest) }}%</td>
            </tr>
            <tr>
                <td>Miscellaneous</td>
                <td>{{ currencyFormat(headOfLoss('misc')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_misc" before-after="pound" :table-control="true">
                            <input autocomplete="off" v-model.number="misc"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('misc') - misc) }}</td>
                <td>{{ roundAndPercent(headOfLoss('misc'), misc) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Miscellaneous - Interest</td>
                <td>{{ currencyFormat(headOfLoss('miscWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_misc" before-after="pound" :table-control="true">
                            <input autocomplete="off" v-model.number="miscInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('miscWithInterest') - miscInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('miscWithInterest'), miscInterest) }}%</td>
            </tr>
            </tbody>
            <custom-head-of-loss
                    v-for="custom in customHeadsOfLoss"
                    :headOfLoss="custom"
                    :index="index"
                    :showInterest="showInterest"
                    @update="updateTotals"
            ></custom-head-of-loss>
            <tbody>
            <tr>
                <td>Past Cost of Care</td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfCare')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_cost_of_care" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastCostOfCare"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfCare') - pastCostOfCare) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastCostOfCare'), pastCostOfCare) }}%</td>
            </tr>
            <tr v-if="showInterest">
                <td>Past Cost of Care - Interest</td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfCareWithInterest')) }}</td>
                <td>
                    <div class="a-form-inputs">
                        <control for="dependants_assessment_past_cost_of_care" before-after="pound"
                                 :table-control="true">
                            <input autocomplete="off" v-model.number="pastCostOfCareInterest"
                                   v-field-control
                                   required
                                   v-two-dp
                                   type="number"
                                   @input="updateTotals">
                        </control>
                    </div>
                </td>
                <td>{{ currencyFormat(headOfLoss('pastCostOfCareWithInterest') - pastCostOfCareInterest) }}</td>
                <td>{{ roundAndPercent(headOfLoss('pastCostOfCareWithInterest'), pastCostOfCareInterest) }}%</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td>Total</td>
                <td>{{ currencyFormat(headsOfLossTotal) }} </td>
                <td>{{ currencyFormat(dependantsHeadsOfLossTotal) }}</td>
                <td>{{ currencyFormat(differenceTotal) }}</td>
                <td>{{ roundAndPercent(headsOfLossTotal, dependantsHeadsOfLossTotal) }}%</td>
            </tr>
            </tfoot>
        </table>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Vue from 'vue';
    import moment from 'moment';
    import dateFormat from 'mixins/dateFormat';
    import currencyFormat from 'mixins/currencyFormat';
    import Control from 'components/form/Control.vue';
    import percentageDifference from 'mixins/percentageDifference';
    import roundValue from 'mixins/roundValue';
    import customHeadOfLoss from 'components/documents/CustomHeadOfLoss.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    const numberVal = value => parseFloat(value || 0);

    export default {
        name: 'fatal-estate-comparison-schedule',
        props: [
            'document',
            'index'
        ],
        mixins: [
            dateFormat,
            currencyFormat,
            roundValue,
            percentageDifference
        ],
        components: {
            customHeadOfLoss,
            Control
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('fatal/estate/headsOfLoss', {
                headOfLoss: 'value',
                totalInterest: 'totalInterest',
                customHeadsOfLoss: 'headsOfLoss',
            }),
            ...mapGetters('documents', {
                getDocumentDataByKey: 'getDocumentDataByKey',
                getGeneratedDocument: 'getGeneratedDocument',
                getEditingDocument: 'getEditingDocument',
                getShowInterest: 'getShowInterest',
            }),
            comparisonSchedule: {
                get() {
                    return this.document;
                }
            },
            pastDependencyOnIncome: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastDependencyOnIncome', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastDependencyOnIncome', value, index: this.index});
                }
            },
            pastDependencyOnIncomeInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastDependencyOnIncomeWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastDependencyOnIncomeWithInterest', value, index: this.index});
                }
            },
            futureDependencyOnIncome: {
                get() {
                    return this.getDocumentDataByKey({key: 'futureDependencyOnIncome', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'futureDependencyOnIncome', value, index: this.index});
                }
            },
            pastDependencyOnServices: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastDependencyOnServices', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastDependencyOnServices', value, index: this.index});
                }
            },
            pastDependencyOnServicesInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastDependencyOnServicesWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastDependencyOnServicesWithInterest', value, index: this.index});
                }
            },
            futureDependencyOnServices: {
                get() {
                    return this.getDocumentDataByKey({key: 'futureDependencyOnServices', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'futureDependencyOnServices', value, index: this.index});
                }
            },
            generalDamages: {
                get() {
                    return this.getDocumentDataByKey({key: 'generalDamages', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'generalDamages', value, index: this.index});
                }
            },
            generalDamagesInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'generalDamagesWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'generalDamagesWithInterest', value, index: this.index});
                }
            },
            bereavementAward: {
                get() {
                    return this.getDocumentDataByKey({key: 'bereavementAward', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'bereavementAward', value, index: this.index});
                }
            },
            bereavementAwardInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'bereavementAwardWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'bereavementAwardWithInterest', value, index: this.index});
                }
            },
            funeralExpenses: {
                get() {
                    return this.getDocumentDataByKey({key: 'funeralExpenses', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'funeralExpenses', value, index: this.index});
                }
            },
            funeralExpensesInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'funeralExpensesWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'funeralExpensesWithInterest', value, index: this.index});
                }
            },
            lossOfSpouse: {
                get() {
                    return this.getDocumentDataByKey({key: 'lossOfSpouse', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'lossOfSpouse', value, index: this.index});
                }
            },
            lossOfSpouseInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'lossOfSpouseWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'lossOfSpouseWithInterest', value, index: this.index});
                }
            },
            pastLossOfEarnings: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastLossOfEarnings', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastLossOfEarnings', value, index: this.index});
                }
            },
            pastLossOfEarningsInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastLossOfEarningsWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastLossOfEarningsWithInterest', value, index: this.index});
                }
            },
            pastCostOfTravel: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastCostOfTravel', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastCostOfTravel', value, index: this.index});
                }
            },
            pastCostOfTravelInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastCostOfTravelWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastCostOfTravelWithInterest', value, index: this.index});
                }
            },
            pastCostOfCare: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastCostOfCare', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastCostOfCare', value, index: this.index});
                }
            },
            pastCostOfCareInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'pastCostOfCareWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'pastCostOfCareWithInterest', value, index: this.index});
                }
            },
            misc: {
                get() {
                    return this.getDocumentDataByKey({key: 'misc', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'misc', value, index: this.index});
                }
            },
            miscInterest: {
                get() {
                    return this.getDocumentDataByKey({key: 'miscWithInterest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'miscWithInterest', value, index: this.index});
                }
            },
            interest: {
                get() {
                    return this.getDocumentDataByKey({key: 'interest', index: this.index});
                },
                set(value) {
                    this.updateDataByKey({key: 'interest', value, index: this.index});
                }
            },
            showInterest: {
                get() {
                    return this.getShowInterest(this.index);
                },
                set(value) {
                    this.updateShowInterest({index: this.index});
                }
            },
            headsOfLossTotal() {
                return numberVal(this.headOfLoss('generalDamages')) +
                    numberVal(this.headOfLoss('bereavementAward')) +
                    numberVal(this.headOfLoss('lossOfSpouse')) +
                    numberVal(this.headOfLoss('pastLossOfEarnings')) +
                    numberVal(this.headOfLoss('pastCostOfTravel')) +
                    numberVal(this.headOfLoss('funeralExpenses')) +
                    numberVal(this.headOfLoss('pastCostOfCare')) +
                    numberVal(this.headOfLoss('misc')) +
                    numberVal(this.calcCustomHeadsOfLoss) +
                    numberVal(this.calcInterest);
            },
            calcCustomHeadsOfLoss(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    this.customHeadsOfLoss.forEach(function (customHead, index) {
                        total = total + numberVal(customHead.value);
                    });
                }
                return total;
            },
            calcInterest(){
                if (!this.showInterest) {
                    return 0;
                }

                return numberVal(this.headOfLoss('generalDamagesWithInterest')) +
                    numberVal(this.headOfLoss('lossOfSpouseWithInterest')) +
                    numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) +
                    numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) +
                    numberVal(this.headOfLoss('funeralExpensesWithInterest')) +
                    numberVal(this.headOfLoss('pastCostOfCareWithInterest')) +
                    numberVal(this.headOfLoss('miscWithInterest')) +
                    numberVal(this.calcCustomHeadsOfLossInterest);
            },
            calcCustomHeadsOfLossInterest(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    this.customHeadsOfLoss.forEach(function (customHead, index) {
                        total = total + numberVal(customHead.interestAccrued);
                    });
                }
                return total;
            },
            dependantsHeadsOfLossTotal() {
                return numberVal(this.getDocumentDataByKey({key: 'generalDamages', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'lossOfSpouse', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastLossOfEarnings', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastCostOfTravel', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'funeralExpenses', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastCostOfCare', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'misc', index: this.index})) +
                    numberVal(this.dependantsHeadsOfLossInterest) +
                    numberVal(this.calcCustomDependantsHeadsOfLoss);
            },
            dependantsHeadsOfLossInterest() {
                if (!this.showInterest) {
                    return 0;
                }

                return numberVal(this.getDocumentDataByKey({key: 'generalDamagesWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'lossOfSpouseWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastLossOfEarningsWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastCostOfTravelWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'funeralExpensesWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'pastCostOfCareWithInterest', index: this.index})) +
                    numberVal(this.getDocumentDataByKey({key: 'miscWithInterest', index: this.index})) +
                    numberVal(this.calcCustomDependantsHeadsOfLossInterest);
            },
            calcCustomDependantsHeadsOfLoss(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    let index = this.index;
                    this.customHeadsOfLoss.forEach((customHead) => {
                        total = total + numberVal(this.getDocumentDataByKey({key: customHead.name, index: index}));
                    });
                }
                return total;
            },
            calcCustomDependantsHeadsOfLossInterest(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    let index = this.index;
                    this.customHeadsOfLoss.forEach((customHead) => {
                        total = total + numberVal(this.getDocumentDataByKey({
                                key: customHead.name + 'WithInterest',
                                index: index
                            }));
                    });
                }
            },
            differenceTotal(){
                return this.headsOfLossTotal - this.dependantsHeadsOfLossTotal;
            }
        },
        methods: {
            ...mapActions('documents', {
                saveGeneratedDocument: 'saveGeneratedDocument',
                toggleContent: 'toggleEditingDocument',
                updateDataByKey: 'updateDataByKey',
                updateDocument: 'updateDocument',
                updateShowInterest: 'updateShowInterest',
            }),
            saveDocument() {
                this.document.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
                this.saveGeneratedDocument({index: this.index, document: this.document});
                this.toggleContent(-1);
            },
            roundAndPercent(val1, val2) {
                return this.roundValue(this.percentageDifference(val1, val2), 2);
            },
            updateTotals() {
                this.headsOfLossTotal;
                this.dependantsHeadsOfLossTotal;
                this.differenceTotal;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// FatalEstateComparisonSchedule.vue?6c619410